
import XLSX from 'xlsx'
import XLSXD from 'xlsx-style'
export class ExcelHelper {
  _SheetJSFT = [
    'xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'
  ].map(function (x) { return '.' + x }).join(',')
  data = ['SheetJS'.split(''), '1234567'.split('')]

    /**
     * 生成并下载excel
     * @param datas 数据
     * @param fileName 文件名
     */
  public downloadExcel (datas: any[], fileName: string = 'sheetjs.xlsx') {
    const ws = XLSX.utils.aoa_to_sheet(datas)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
    /* generate file and send to client */
    XLSX.writeFile(wb,fileName)
  }


  public downloadExcelMerges(datas: any[], fileName: string = 'sheetjs.xlsx', merges: any = []) {

        const ws = XLSX.utils.aoa_to_sheet(datas)
        ws['!merges'] = merges;
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')

        /* generate file and send to client */
        XLSX.writeFile(wb, fileName)
    }

  public downloadExcelSheets(datas:Map<string,any[]>, fileName: string = 'sheetjs.xlsx'){
      const wb = XLSX.utils.book_new()
      datas.forEach((value,key)=>{

        const ws = XLSX.utils.aoa_to_sheet(value)
        XLSX.utils.book_append_sheet(wb, ws, key)
      })
      
      XLSX.writeFile(wb,fileName)
  }
  public importExcel () {
    console.log('importExcel')
  }
  public exportExcel () {
    console.log('exportExcel')
  }
    /**
   * 转换Excel日期
   * @param numb 
   * @param format 
   * @returns 
   */
     public formatExcelDate(numb, format) {
      const time = new Date((numb - 1) * 24 * 3600000 + 1)
      time.setFullYear(time.getFullYear() - 70)
      const year = time.getFullYear() + ''
      const month = time.getMonth() + 1
      const date = time.getDate()
      if (format && format.length === 1) {
        return year + format + month + format + date
      }
      return year + (month < 10 ? '0' + month : `${month}`) + (date < 10 ? '0' + date : `${date}`)
    }

    /**
   * @description: 生成并下载excel(自定义样式)
   * @param {any} datas
   * @param {string} fileName
   * @param {any} merges
   * @param {any} setStyle
   * @return {*}
   * @author: pangting
   */
  public downloadExcelAndSetStyle(datas: any[], fileName: string = 'sheetjs.xlsx', merges: any = [], setStyle: any) {
    const wb = XLSX.utils.book_new()
    const ws: any = XLSX.utils.json_to_sheet(datas, {
      skipHeader: true,
    });
    ws['!merges'] = merges;
    if (setStyle) {
      setStyle(ws)
    }
    XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
    let config:any=[
      this.s2ab(
        XLSXD.write(wb, { bookType: 'xlsx', type: 'binary', bookSST: true, cellStyles: true })
      )
    ]

    const tmpDown:any = new Blob(config)
    this.downloadExcelFile(tmpDown, fileName)
  }


  
  s2ab(s: any){
    if (typeof ArrayBuffer !== 'undefined') {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    } else {
      const buf:string[] = new Array(s.length)
      for (let i = 0; i != s.length; ++i) {
        buf[i] = String(s.charCodeAt(i) & 0xff)
      }
      return buf
    }
  }

  downloadExcelFile(obj, fileName) {
    const a_node = document.createElement('a')
    a_node.download = fileName
    if ('msSaveOrOpenBlob' in navigator) {
      (navigator as any).msSaveOrOpenBlob(obj, fileName)
    } else {
      a_node.href = URL.createObjectURL(obj)
    }
    a_node.click()
    setTimeout(() => {
      URL.revokeObjectURL(obj)
    }, 2000)
  }

}
